import React from 'react';
import RupeeIcon from '../../../icons/Rupee';
import CircleSpinner from '../../Common/CircleSpinner/CircleSpinner';
import * as S1 from '../../Common/common-elements.styles';
import * as S from '../SrpCard/srp-card-ui.styles';
import PriceLockTag from '../PriceLockTag/price-lock-tag';

export default function FareOptions({
  staticTexts,
  postSearchRkeysData,
  ancillaryList,
  showPriceLoader,
  onBookClickHandler = index => {},
  handlePriceLockTagClick,
  selectedFlight,
  showLoaderOnBookButton = false,
  messageValues
}) {
  const priceLockTagDetails = staticTexts?.cta?.sd?.l_cta?.cd?.lock_price || {};
  const {
    t: bookButtonText = 'BOOK',
    bg: bookButtonBgColor,
    br: bookButtonBorderColor
  } = staticTexts?.cta?.sd?.r_cta?.cd?.book || {};

  return ancillaryList.map((ancillary, index) => {
    const fareDetail = postSearchRkeysData?.[ancillary?.fareKey]?.fareDetail || {};
    const hasPriceLock =
      postSearchRkeysData?.[ancillary?.fareKey]?.['fr_lock']?.['isAvailable'] || false;
    let ffBgColor = '',
      ffColor = '',
      ffOfferText = '';
    const hasOfferText = postSearchRkeysData?.[ancillary?.fareKey]?.['cp']?.['ff_color'] || false;
    if (hasOfferText) {
      const { ff_bgcolor, ff_color, text } = postSearchRkeysData?.[ancillary?.fareKey]?.['cp'];
      ffBgColor = ff_bgcolor;
      ffColor = ff_color;
      ffOfferText = text;
    }

    return (
      <div className="flexCol" key={'FareOption_' + index}>
        <div className="flexCol padT20 padB20 borderTop">
          <div className="padR20 padL20 dF justifyBetween">
            <S.ViewFaresLeft className="flexCol">
              <div className="marginB15">
                <div className="dF alignItemsCenter">
                  {ancillary.headerIcon ? (
                    <img
                      src={`https://gos3.ibcdn.com/${ancillary.headerIcon}`}
                      width="74"
                      height="22"
                      className="padL5"
                      alt="ancillary_header"
                      loading="lazy"
                    />
                  ) : null}
                  <span className="font18 f600 padR5">{ancillary.header}</span>
                  {ancillary.tag ? (
                    <img
                      width="60"
                      height="30"
                      src={`https://gos3.ibcdn.com/${ancillary.tag}`}
                      alt="ancillary_tag"
                      loading="lazy"
                    />
                  ) : null}
                  {(ancillary?.persuasionText && !ancillary?.isCustomFareFamily && (
                    <span
                      className="upgardeFFtag"
                      dangerouslySetInnerHTML={{ __html: ancillary.persuasionText }}
                    ></span>
                  )) ||
                    null}
                </div>
                {ancillary?.persuasionText && ancillary?.isCustomFareFamily ? (
                  <S.Persuasion
                    bgColor={ancillary.persuasionBackgroundColor}
                    className="marginT5"
                    dangerouslySetInnerHTML={{ __html: ancillary.persuasionText }}
                  ></S.Persuasion>
                ) : null}
              </div>
              {ancillary?.detailsList?.map(item => (
                <div className="dF padB5 alignItemsStart" key={item.t}>
                  <S.Col5 className="dF padL0 alignItemsCenter">
                    <img
                      src={`https://gos3.ibcdn.com/${item.i}`}
                      width="12"
                      height="12"
                      alt="ancillary_details_list"
                      loading="lazy"
                    />
                    <span
                      className="padL5 greyCnt"
                      dangerouslySetInnerHTML={{
                        __html: item.t.split('\n').join(', ')
                      }}
                    ></span>
                  </S.Col5>
                  <S.Col5
                    dangerouslySetInnerHTML={{ __html: item?.v?.split('\n').join(', ') }}
                  ></S.Col5>
                </div>
              ))}
            </S.ViewFaresLeft>
            <div className="dF">
              <span
                className={`flexCol alignItemsEnd padB5 ${showPriceLoader ? 'priceContainer' : ''}`}
              >
                {!showPriceLoader ? (
                  <>
                    <span className="alignItemsCenter dF padT2">
                      {fareDetail?.prices ? (
                        <span
                          className="font18 f600"
                          dangerouslySetInnerHTML={{ __html: fareDetail?.prices }}
                        ></span>
                      ) : (
                        <>
                          <RupeeIcon width="1rem" height="1rem" fill="#333333" loading="lazy" />
                          <span className="font18 f600">{ancillary.bundleAmt}</span>
                        </>
                      )}
                    </span>
                    {fareDetail?.additionalInfo ? (
                      <span
                        className="font12 f400 greyCnt"
                        dangerouslySetInnerHTML={{ __html: fareDetail?.additionalInfo }}
                      ></span>
                    ) : null}
                  </>
                ) : (
                  <S1.AnimatedBackground className="width80 padT20"></S1.AnimatedBackground>
                )}
              </span>
              <S.ButtonOuter className="flexCol">
                <span className="dF flexCol">
                  <span className="db clearfix posRel">
                    {showLoaderOnBookButton && index === selectedFlight?.bundleIndex && (
                      <CircleSpinner bkFlt={true} />
                    )}
                    <S.Fltbook
                      className="f600 widthF105 fareFamilyBookBtn"
                      value={bookButtonText}
                      onClick={() => onBookClickHandler(index)}
                      bgColor={bookButtonBgColor}
                      brColor={bookButtonBorderColor}
                    />
                  </span>
                </span>

                {hasPriceLock && priceLockTagDetails?.t && (
                  <PriceLockTag
                    details={priceLockTagDetails}
                    actionHandler={() =>
                      handlePriceLockTagClick({ rKeys: [ancillary?.fareKey || ''] })
                    }
                  />
                )}
              </S.ButtonOuter>
            </div>
          </div>
          {(hasOfferText && (
            <div className="dF justifyEnd">
              <S.SpecialTag color={ffColor} bgColor={ffBgColor}>
                <span
                  className="f500"
                  dangerouslySetInnerHTML={{ __html: messageValues[ffOfferText] || '' }}
                ></span>
              </S.SpecialTag>
            </div>
          )) ||
            null}
        </div>
      </div>
    );
  });
}
